export enum Action {
	Disable = 'disable',
	DisableClickKeys = 'disableClickKeys',
	DisableKeys = 'disableKeys',
	Enable = 'enable',
	EnableClickKeys = 'enableClickKeys',
	EnableKeys = 'enableKeys',
	End = 'end',
	Home = 'home',
	NextItem = 'nextItem',
	NextPage = 'nextPage',
	PrevItem = 'prevItem',
	PrevPage = 'prevPage',
	SetActiveItem = 'setActiveItem',
	SetTotal = 'setTotal',
	SetPageSize = 'setPageSize',
	SetReturnToIndexOnFocus = 'setReturnToIndexOnFocus',
	UserDisable = 'userDisable',
	UserEnable = 'userEnable',
}

export type Actions =
	| {
			type: Action.Disable;
	  }
	| {
			type: Action.DisableClickKeys;
	  }
	| {
			type: Action.DisableKeys;
	  }
	| {
			type: Action.Enable;
	  }
	| {
			type: Action.EnableClickKeys;
	  }
	| {
			type: Action.EnableKeys;
	  }
	| {
			type: Action.End;
	  }
	| {
			type: Action.Home;
	  }
	| {
			type: Action.NextItem;
	  }
	| {
			type: Action.NextPage;
	  }
	| {
			type: Action.PrevItem;
	  }
	| {
			type: Action.PrevPage;
	  }
	| {
			type: Action.SetActiveItem;
			index: number;
	  }
	| {
			type: Action.SetPageSize;
			pageSize: number;
	  }
	| {
			type: Action.SetReturnToIndexOnFocus;
			index: number;
	  }
	| {
			type: Action.SetTotal;
			total: number;
	  }
	| {
			type: Action.UserDisable;
	  }
	| {
			type: Action.UserEnable;
	  };
